import React from "react";
import "./VitaminsDetailPage.css";

const vitaminData = {
    name: "Pharmaton Vitality Tablet",
    description:
        "Pharmaton® Vitality®, enerji artırıcı ve bağışıklık destekleyici bir multivitamin ve mineral takviyesidir. İçeriğinde Ginseng G115®, 12 vitamin ve 6 mineral bulunmaktadır.",
    benefits: [
        "Enerji seviyesini artırır.",
        "Bağışıklık sistemini güçlendirir.",
        "Yorgunluk ve bitkinliği azaltır.",
        "Günlük vitamin ve mineral ihtiyaçlarını destekler.",
    ],
    usage: "Günde bir kapsül, tercihen sabah kahvaltıdan sonra su ile alınmalıdır.",
    risks: [
        "Hamilelik ve emzirme döneminde doktorunuza danışınız.",
        "Kan sulandırıcı ilaç kullananlar dikkatli olmalıdır.",
        "Soya içerir; soya alerjisi olan bireyler için uygun olmayabilir.",
        "Demir içeriği mide rahatsızlığına neden olabilir.",
    ],
    ingredients: [
        {
            name: "Panax Ginseng Ekstresi",
            amount: "17,4 mg",
            dailyIntakePercentage: "N/A",
            details: "Enerji artırır, stresi azaltır ve zihinsel performansı destekler.",
        },
        {
            name: "C Vitamini",
            amount: "80 mg",
            dailyIntakePercentage: "100%",
            details: "Bağışıklığı güçlendirir, yorgunluğu azaltır ve vücudu serbest radikallere karşı korur.",
        },
        {
            name: "D Vitamini",
            amount: "6 µg",
            dailyIntakePercentage: "120%",
            details: "Kemiklerin güçlü olmasını sağlar ve bağışıklık fonksiyonlarını destekler.",
        },
        {
            name: "E Vitamini",
            amount: "12 mg",
            dailyIntakePercentage: "100%",
            details: "Hücreleri oksidatif strese karşı korur ve cilt sağlığını destekler.",
        },
        {
            name: "Çinko",
            amount: "10 mg",
            dailyIntakePercentage: "100%",
            details: "Bağışıklığı güçlendirir, cilt sağlığını destekler ve yaraların iyileşmesine yardımcı olur.",
        },
        {
            name: "Demir",
            amount: "8,3 mg",
            dailyIntakePercentage: "59%",
            details: "Kanın oksijen taşıma kapasitesini artırır ve yorgunluğu azaltır.",
        },
        {
            name: "Folik Asit (Vitamin B9)",
            amount: "300 µg",
            dailyIntakePercentage: "150%",
            details: "Hücre bölünmesi ve DNA sentezi için gereklidir.",
        },
        {
            name: "Biotin",
            amount: "38 µg",
            dailyIntakePercentage: "76%",
            details: "Saç ve cilt sağlığını korur, enerji üretimini destekler.",
        },
        {
            name: "Magnezyum",
            amount: "77,5 mg",
            dailyIntakePercentage: "21%",
            details: "Kas fonksiyonları ve enerji metabolizmasında önemli rol oynar.",
        },
        {
            name: "Bakır",
            amount: "1 mg",
            dailyIntakePercentage: "100%",
            details: "Demirin emilimine yardımcı olur, bağışıklık ve sinir sistemi sağlığını destekler.",
        },
    ],
    reviews: {
        positive: [
            "Enerji seviyemi artırdı, kesinlikle öneririm!",
            "Uzun süre kullanımda etkisini gördüm, bağışıklık sistemimi güçlendirdi.",
        ],
        negative: [
            "Fiyatı biraz yüksek.",
            "Midemde hafif rahatsızlık yaptı.",
        ],
        summary: {
            positives: "Kullanıcılar genellikle ürünün enerji artırıcı etkisinden ve bağışıklık güçlendirmesinden memnun.",
            negatives: "Bazı kullanıcılar fiyatın yüksekliğinden ve mide rahatsızlıklarından şikayetçi.",
        },
    },
};

const VitaminsDetailPage = () => {
    return (
        <div className="vitamins-page">
            <header className="vitamins-header">
                <h1>{vitaminData.name}</h1>
                <p>{vitaminData.description}</p>
            </header>

            <section className="section benefits">
                <h2>Faydaları</h2>
                <ul>
                    {vitaminData.benefits.map((benefit, index) => (
                        <li key={index}>{benefit}</li>
                    ))}
                </ul>
            </section>

            <section className="section ingredients">
                <h2>İçindekiler</h2>
                <ul>
                    {vitaminData.ingredients.map((ingredient, index) => (
                        <li key={index}>
                            <strong>{ingredient.name}:</strong> {ingredient.amount} - {ingredient.details}{" "}
                            (Günlük İhtiyaç: {ingredient.dailyIntakePercentage})
                        </li>
                    ))}
                </ul>
            </section>

            <section className="section risks">
                <h2>Potansiyel Riskler</h2>
                <ul>
                    {vitaminData.risks.map((risk, index) => (
                        <li key={index}>{risk}</li>
                    ))}
                </ul>
            </section>

            <section className="section reviews">
                <h2>Kullanıcı Yorumları</h2>
                <h3>Olumlu Yorumlar</h3>
                <ul>
                    {vitaminData.reviews.positive.map((review, index) => (
                        <li key={index}>{review}</li>
                    ))}
                </ul>
                <h3>Olumsuz Yorumlar</h3>
                <ul>
                    {vitaminData.reviews.negative.map((review, index) => (
                        <li key={index}>{review}</li>
                    ))}
                </ul>
                <p>
                    <strong>Özet:</strong> {vitaminData.reviews.summary.positives} {vitaminData.reviews.summary.negatives}
                </p>
            </section>
        </div>
    );
};

export default VitaminsDetailPage;
